import {
    getFirstDayOfMounthAndHours000000WithoutUTC,
    getLastDayOfMounthAndHours235959WithoutUTC,
} from '../../utils/date.utils'

export function getDefaultAnalizPricePeriod() {
    const now = new Date()
    return {
        start: getFirstDayOfMounthAndHours000000WithoutUTC(now),
        end: getLastDayOfMounthAndHours235959WithoutUTC(now),
    }
}

/**
 * While the popup is open, ignore parent re-renders that would reset calendar
 * values/currentDate (year arrows then look "dead"). Also skip the focus jump
 * that happens on popup show, but keep native start→end move after a real pick.
 */
export function attachDateRangeBoxGuards(component) {
    const strategy = component?.getStartDateBox?.()?._strategy
    if (!strategy || strategy._lkkGuardsAttached) {
        return
    }
    strategy._lkkGuardsAttached = true

    const origUpdateValue = strategy._updateValue.bind(strategy)
    strategy._updateValue = function() {
        if (this._widget && this.dateRangeBox?.option('opened')) {
            return
        }
        return origUpdateValue()
    }

    const origShowing = strategy.popupShowingHandler.bind(strategy)
    strategy.popupShowingHandler = function() {
        this._shouldPreventFocusChange = true
        this._dateSelectedCounter = 0
        const result = origShowing()
        patchCalendarKeepViewOnSelect(this._widget)
        return result
    }

    strategy._moveFocusToNextInput = function() {
        const next = 'startDate' === this._getCalendarCurrentSelection() ? 'endDate' : 'startDate'
        this.dateRangeBox.option('_currentSelection', next)
        if (this._widget) {
            this._widget.option('_currentSelection', next)
        }
    }

    patchCalendarKeepViewOnSelect(strategy._widget)
}

function patchCalendarKeepViewOnSelect(calendar) {
    if (!calendar || calendar._lkkKeepViewOnSelect) {
        return
    }
    calendar._lkkKeepViewOnSelect = true
    const origUpdateCurrentDate = calendar._updateCurrentDate.bind(calendar)
    calendar._updateCurrentDate = function(date) {
        const skip = this._skipNavigate
        if (skip) {
            this._suppressNavigation = true
        }
        try {
            return origUpdateCurrentDate(date)
        } finally {
            if (skip) {
                this._suppressNavigation = false
            }
        }
    }
}
